import { useTranslation } from 'react-i18next'

import { useTimeZone, useUserData } from '../../../../../../hooks'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { ApplicantDecisionActions } from '../ApplicantDecisionActions'
import {
  APPLICANT_DECISION_STEP,
  QA_NAME_APPLICANT_DECISION_APPROVAL_RULE,
  QA_NAME_APPLICANT_DECISION_REVIEWER,
} from '../ApplicantDecisionPanel.constants'
import { getApplicantDecisionApprovalActions } from '../ApplicantDecisionPanel.utils.actions'
import {
  getApplicantDecisionApprovalPeople,
  getApplicantDecisionApprovalsStep,
} from '../ApplicantDecisionPanel.utils.rows'
import { ApplicantDecisionPerson } from '../ApplicantDecisionPerson'
import { ApplicantDecisionStep } from '../ApplicantDecisionStep'

function ApplicantDecisionApprovalStep({ onClickAction }) {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const timezone = useTimeZone()

  const { applicantData, isPreview } = useApplicantProfileContext()

  return (
    <ApplicantDecisionStep
      {...getApplicantDecisionApprovalsStep({ applicantData, t })}
      qaName={QA_NAME_APPLICANT_DECISION_APPROVAL_RULE}
      step={APPLICANT_DECISION_STEP.approval}
    >
      {getApplicantDecisionApprovalPeople({ applicantData, t, timezone }).map(
        ({ id, ...personProps }) => (
          <ApplicantDecisionPerson
            {...personProps}
            key={id}
            qaName={QA_NAME_APPLICANT_DECISION_REVIEWER}
          />
        )
      )}
      <ApplicantDecisionActions
        actions={getApplicantDecisionApprovalActions({
          applicantData,
          currentUserId: currentUser?.id,
          isPreview,
          t,
        })}
        onClick={onClickAction}
      />
    </ApplicantDecisionStep>
  )
}

export default ApplicantDecisionApprovalStep
